export const SHOWMODAL = 'SHOWMODAL';
export const UPDATEMORTGAGES = 'UPDATEMORTGAGES';
export const TABSPAGE = 'TABSPAGE';
export const ANALYST = 'ANALYST';